import { render } from "./InventoryItemDetailsTab.vue?vue&type=template&id=1bf51e14"
import script from "./InventoryItemDetailsTab.vue?vue&type=script&lang=js"
export * from "./InventoryItemDetailsTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__